import React, { useEffect, useRef } from 'react';
import Quill from 'quill';
import 'quill/dist/quill.snow.css';

const QuillEditor = ({ value, onChange }) => {
  const editorRef = useRef(null);
  const quillInstance = useRef(null);
  const isSettingContent = useRef(false);

  useEffect(() => {
    if (editorRef.current && !quillInstance.current) {
      quillInstance.current = new Quill(editorRef.current, {
        theme: 'snow',
        placeholder: 'Write something...',
        modules: {
          toolbar: [
            [{ header: [1, 2, 3, false] }],
            ['bold', 'italic', 'underline'],
            [{ list: 'ordered' }, { list: 'bullet' }],
            ['link', 'blockquote', 'code-block'],
          ],
        },
      });

      quillInstance.current.on('text-change', () => {
        if (isSettingContent.current) {
          // Skip triggering onChange when we are programmatically setting content
          isSettingContent.current = false;
          return;
        }
        const content = quillInstance.current.root.innerHTML;
        if (onChange) onChange(content);
      });
    }
  }, [onChange]);

  // Update the editor content when `value` changes from outside (like loading initial data)
  useEffect(() => {
    if (quillInstance.current) {
      const currentContent = quillInstance.current.root.innerHTML;
      if (value !== currentContent) {
        isSettingContent.current = true;
        quillInstance.current.root.innerHTML = value || '';
      }
    }
  }, [value]);

  return (
    <div>
      <div ref={editorRef} style={{ height: '300px' }} />
    </div>
  );
};

export default QuillEditor;
